<template>
  <div class="autocomplete">
    <v-autocomplete
      v-model="customer"
      @keyup="search"
      @change="handleSelect"
      @click:clear="clear"
      :no-data-text="$t('customer.label.noData')"
      :label="$t('customer.label.search')"
      :density="density"
      :items="customers"
      prepend-inner-icon="mdi-magnify"
      item-value="id"
      item-text="name"
      return-object
      clearable
      outlined
    />
    <v-progress-circular
      v-show="isCustomersLoading"
      class="autocomplete-loading"
      color="primary"
      width="1.5"
      size="13"
      indeterminate
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'HServiceProviderSelect',

  props: {
    defaultValue: {
      default: null,
    },

    density: {
      type: 'default' | 'comfortable' | 'compact',
      default: 'default',
    },
  },

  computed: {
    ...mapGetters(['customers']),
  },

  methods: {
    ...mapActions(['searchCustomers']),
    ...mapMutations(['setFilters', 'setCustomers']),

    handleSelect(value) {
      if (!value) return
      this.$emit('input', this.customer)
      return
    },

    search({ target }) {
      const term = target?.value
      if (!term && term?.length <= 3) return

      clearTimeout(this.timer)

      this.isCustomersLoading = true
      // this.setFilters({ search: term })

      this.timer = setTimeout(() => {
        this.searchCustomers(term)
          .finally(() => this.isCustomersLoading = false)
      }, 1000)
    },

    clear() {
      this.customer = null
      this.$emit('input', null)
    },
  },

  watch: {
    defaultValue(value) {
      if (!value) return

      this.setCustomers([value])
      this.$nextTick(() => this.customer = value)
    },
  },

  data() {
    return {
      customer: null,
      isCustomersLoading: false,
      timer: null,
    }
  },
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-loading {
  position: absolute;
  top: 28px;
  right: 73px;
  transform: translateY(-50%);
}
</style>

